module.exports = __webpack_public_path__ + "img/auto_spin_btn.401dc47f.png";